import React, { useState, useEffect } from "react";
import { Card } from "flowbite-react";
import clsx from "clsx";
import { NextArrow } from "../../common/icons";

export default function PaymentMethod({
  pmName,
  directLink,
  locationData,
  toggleShowAccordion,
  pwpData,
  index,
  bcState,
  isUserLogged,
  languages,
}) {


  if (!pmName) return;
  if (pmName && pmName === "Stripe") {
    
    return (
      <div
        className="holder-payment-button mb-3"
        onClick={() => toggleShowAccordion(pmName)}
      >
        <div class="payment-button flex">
          <React.Fragment>
            {locationData.PaymentMethod[pmName].Image.map((i) => {
              if (
                locationData.PaymentMethod[pmName].Image &&
                locationData.PaymentMethod[pmName].Image.length > 0
              ) {
                let img = require("../../assets/images/" + i);
                return <img src={img} width="42" class="mr-2" />;
              } else {
                return locationData.PaymentMethod[pmName].TabName || pmName;
              }
            })}
          </React.Fragment>
          {/* <p className='font-montserrat font-bold'>{locationData.PaymentMethod[pmName]?.TabName || pmName}</p> */}
          <NextArrow className={"icon-next-arrow"} />
        </div>
      </div>
    );
  }

  if ((pmName && pmName == "AsiaPay") || pmName == "DIRECT") {
    
    return (
      <div
        className="holder-payment-button mb-3"
        onClick={() => toggleShowAccordion(pmName)}
      >
        <div class="payment-button flex">
          <React.Fragment>
            {locationData.PaymentMethod[index].pMethod.map((i) => {
              if (i) {
                //return (i.image ? i.image : "test");
                let img, imgSize;
                if (
                  locationData.PaymentMethod[index].dinerBC &&
                  bcState == locationData.PaymentMethod[index].dinerBC &&
                  locationData.PaymentMethod[index].dinerProps
                ) {
                  img = require("../../assets/images/" +
                    locationData.PaymentMethod[index].dinerProps.image);
                  imgSize =
                    locationData.PaymentMethod[index].dinerProps.widthSize;
                } else if (
                  locationData.PaymentMethod[index].visaBC &&
                  bcState == locationData.PaymentMethod[index].visaBC &&
                  locationData.PaymentMethod[index].visaProps
                ) {
                  img = require("../../assets/images/" +
                    locationData.PaymentMethod[index].visaProps.image);
                  imgSize =
                    locationData.PaymentMethod[index].visaProps.widthSize;
                } else if (
                  locationData.PaymentMethod[index].jcbBC &&
                  bcState == locationData.PaymentMethod[index].jcbBC &&
                  locationData.PaymentMethod[index].jcbProps
                ) {
                  img = require("../../assets/images/" +
                    locationData.PaymentMethod[index].jcbProps.image);
                  imgSize =
                    locationData.PaymentMethod[index].jcbProps.widthSize;
                } else {
                  img = require("../../assets/images/" + i.image);
                  imgSize = i.widthSize;
                }
                return <img src={img} width={imgSize} />;
              } else {
                return locationData.PaymentMethod[index].TabName || pmName;
              }
            })}
          </React.Fragment>
          {/* <p className='font-montserrat font-bold'>{locationData.PaymentMethod[pmName]?.TabName || pmName}</p> */}
          <NextArrow className={"icon-next-arrow"} />
        </div>
      </div>
    );
  }

  if (pmName && pmName == "LimePay") {    
    return (
      <div
        className="holder-payment-button mb-3"
        onClick={() => toggleShowAccordion(pmName)}
      >
        <div class="payment-button flex">
          {locationData.PaymentMethod[pmName]?.TabName || pmName}
          {/* <p className='font-montserrat font-bold'>{locationData.PaymentMethod[pmName]?.TabName || pmName}</p> */}
          <NextArrow className={"icon-next-arrow"} />
        </div>
      </div>
    );
  }

  if (directLink) {
    return (
      <div
        className="holder-payment-button mb-3"
        onClick={() => toggleShowAccordion(pmName, directLink)}
      >
        <div class="payment-button flex">
          <div className="flex flex-col content-center">
            {locationData.PaymentMethod[index]?.pMethod
              .filter((pMethod) => {
                let img = require("../../assets/images/" + pMethod.image);
                //return <img src={img} width={pMethod.widthSize} />
                return pMethod.pmCode === pmName;
              })
              .map((i) => {
                if (
                  locationData.PaymentMethod[index].pMethod &&
                  locationData.PaymentMethod[index].pMethod.length > 0
                ) {
                  let img = require("../../assets/images/" + i.image);
                  return <img src={img} width={i.widthSize} />;
                } else {
                  return locationData.PaymentMethod[index].TabName || pmName;
                }
              })}
          </div>
          {/* <p className='font-montserrat font-bold'>{locationData.PaymentMethod[pmName]?.TabName || pmName}</p> */}
          <NextArrow className={"icon-next-arrow"} />
        </div>
      </div>
    );
  }

  if (pmName === "PayWithPoints" && pwpData && isUserLogged) {
    console.log("locdata", locationData.PaymentMethod[pmName]);
    return (
      <div
        className="holder-payment-button mb-3"
        onClick={() => toggleShowAccordion(pmName)}
      >
        <div class="payment-button flex">
          <React.Fragment>
            {locationData.PaymentMethod[pmName].Image.map((i) => {
              if (
                locationData.PaymentMethod[pmName].Image &&
                locationData.PaymentMethod[pmName].Image.length > 0
              ) {
                let img = require("../../assets/images/" + i);
                return (
                  <>
                    <img src={img} />
                    <span className="my-auto pl-3 font-montserrat font-bold">
                      {languages && languages.allRewardPoints
                        ? languages.allRewardPoints
                        : "ALL Reward points"}
                    </span>
                  </>
                );
              } else {
                return locationData.PaymentMethod[pmName].TabName || pmName;
              }
            })}
          </React.Fragment>
          {/* <p className='font-montserrat font-bold'>{locationData.PaymentMethod[pmName]?.TabName || pmName}</p> */}
          <NextArrow className={"icon-next-arrow"} />
        </div>
      </div>
    );
  }
}

// const paymentMethodConfig = {
//     Stripe: { imgWidth: 42 },
//     AsiaPay: { dynamicSizing: true },
//     PAYPAL: { dynamicSizing: true },
//     ZIPPAY: { dynamicSizing: true },
//     LimePay: { imgWidth: 50 },
//     PayWithPoints: { showRewardText: true }
// };

// export default function PaymentMethod({ pmName, directLink, locationData, toggleShowAccordion, pwpData, index, bcState }) {
//     if (!pmName) return null;

//     console.log('pmName', pmName)

//     const { PaymentMethod } = locationData;
//     const config = paymentMethodConfig[pmName] || {};

//     const renderImages = (images, width) =>
//         images.map((img) => (
//             <img key={img} src={require(`../../assets/images/${img}`)} width={width || "auto"} className="mr-2" />
//         ));

//         const renderDynamicImages = (methods) => {
//             console.log("Dynamic methods data:", methods); // Log for troubleshooting

//             const method = methods.find((method) => {
//                 if (config.dynamicSizing) {
//                     if (method.dinerBC && bcState === method.dinerBC) {
//                         return true;
//                     }
//                     if (method.visaBC && bcState === method.visaBC) {
//                         return true;
//                     }
//                     if (method.jcbBC && bcState === method.jcbBC) {
//                         return true;
//                     }
//                     if (method.image) {
//                         return true;
//                     }
//                 }
//                 return false;
//             });

//             if (method) {
//                 let imgSrc;
//                 let imgSize;

//                 if (method.dinerBC && bcState === method.dinerBC) {
//                     imgSrc = require(`../../assets/images/${method.dinerProps.image}`);
//                     imgSize = method.dinerProps.widthSize;
//                 } else if (method.visaBC && bcState === method.visaBC) {
//                     imgSrc = require(`../../assets/images/${method.visaProps.image}`);
//                     imgSize = method.visaProps.widthSize;
//                 } else if (method.jcbBC && bcState === method.jcbBC) {
//                     imgSrc = require(`../../assets/images/${method.jcbProps.image}`);
//                     imgSize = method.jcbProps.widthSize;
//                 } else if (method.image) {
//                     imgSrc = require(`../../assets/images/${method.image}`);
//                     imgSize = method.widthSize || "auto";
//                 }

//                 return <img key={imgSrc} src={imgSrc} width={imgSize} className="mr-2" />;
//             }

//             return pmName; // If no match is found, return the TabName or pmName as a fallback
//         };

//     const renderPaymentMethod = () => {
//         console.log('config', config)
//         // Render PayWithPoints only if pwpData is true
//         if (config?.showRewardText && pmName === "PayWithPoints" && pwpData) {
//             return (
//                 <div className="flex items-center">
//                     {renderImages(PaymentMethod[pmName].Image, 42)}
//                     <span className="pl-3 font-bold">ALL Reward Points</span>
//                 </div>
//             );
//         }

//         // Render dynamic images if enabled in config
//         return config?.dynamicSizing
//             ? renderDynamicImages(PaymentMethod[index]?.pMethod || [])
//             : renderImages(PaymentMethod[pmName]?.Image || [], config.imgWidth);
//     };

//     return (
//         <div className="holder-payment-button mb-3" onClick={() => toggleShowAccordion(pmName, directLink)}>
//             <div className="payment-button flex">
//                 <ErrorBoundary>
//                     {renderPaymentMethod()}
//                     <NextArrow className="icon-next-arrow" />
//                 </ErrorBoundary>
//             </div>
//         </div>
//     );
// }
